/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import styled from '@emotion/styled';

import { breakpoints } from '@coursera/cds-core';

import CategoryHeader from 'bundles/degree-home/components/v3-dpm/components/Category/CategoryHeader';
import Segment from 'bundles/degree-home/components/v3-dpm/components/Segment';
import type { UseCurriculum_DegreeCategoryFragment as CategoryFragmentProps } from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/useCurriculum';
import { Card } from 'bundles/program-loggedin-shared/components/Card';
import categoryIsCollapsed from 'bundles/program-loggedin-shared/libraries/categoryIsCollapsed';

export type CategoryProps = {
  category: CategoryFragmentProps;
  disclaimers?: React.ReactNode;
};

const styles = {
  segmentContainer: () => css`
    &:not(:last-of-type) {
      margin-bottom: var(--cds-spacing-400);
    }
  `,
  categoryMargin: () => css`
    &:not(:last-of-type) {
      margin-bottom: var(--cds-spacing-300);
      ${breakpoints.down('xs')} {
        margin-bottom: var(--cds-spacing-200);
      }
    }
  `,
};

const CategoryCard = styled(Card)`
  /* Handle margin on the categoryMargin styles so it's consistent in both collapsed and non-collapsed */
  margin-bottom: 0;
`;

const Category: React.FC<CategoryProps> = ({ category, disclaimers }) => {
  const collapsed = categoryIsCollapsed({ ...category, segmentLength: category.segments.length });
  const WrappingElement = collapsed ? React.Fragment : CategoryCard;

  return (
    <div css={styles.categoryMargin}>
      <WrappingElement>
        {!collapsed && <CategoryHeader category={category} />}

        <div>
          {category.segments.map((segment) => (
            <div key={segment.id} css={styles.segmentContainer}>
              <Segment segment={segment} />
            </div>
          ))}
        </div>

        {disclaimers && (
          <div style={{ marginBottom: 'var(--cds-spacing-400)', marginTop: 'var(--cds-spacing-300)' }}>
            {disclaimers}
          </div>
        )}
      </WrappingElement>
    </div>
  );
};

export default Category;
